<template>

    <a-modal title="查看标的物"
             :width="800"
             :visible="visible"
             @cancel="$emit('cancel')"
             :maskClosable="false"
             :footer="null"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <a-card>
<!--            <a-table-->
<!--                    :columns="columns"-->
<!--                    :dataSource="subjectList"-->
<!--                    :rowKey="record => record.id"-->
<!--                    :pagination="false">-->
<!--                <template slot="subjectName" slot-scope="text, record">-->
<!--                    {{record.subjectName}}-->
<!--                </template>-->
<!--                <template slot="specifications" slot-scope="text, record">-->
<!--                    {{record.specifications}}-->
<!--                </template>-->
<!--                <template slot="quantity" slot-scope="text, record">-->
<!--                    {{record.quantity}}-->
<!--                </template>-->
<!--                <template slot="unit" slot-scope="text, record">-->
<!--                    {{record.unit}}-->
<!--                </template>-->
<!--                <template slot="ask" slot-scope="text, record">-->
<!--                    {{record.ask}}-->
<!--                </template>-->
<!--                <template slot="remarks" slot-scope="text, record">-->
<!--                    {{record.remarks}}-->
<!--                </template>-->
<!--            </a-table>-->

            <a-table  style="width: 100%"
                      :dataSource="subjectList"
                      :rowKey="record => record.id"
                      :pagination="false">
                <a-table-column  key="subjectName" width="20%" title="名称" data-index="subjectName">
                    <template slot-scope="text,record">
                        {{record.subjectName}}
                    </template>
                </a-table-column>
                <a-table-column v-if="tenderType==='1'" key="specifications" width="20%" title="品牌及规格型号"
                                data-index="specifications">
                    <template slot-scope="text,record">
                        {{record.specifications}}
                    </template>
                </a-table-column>

                <a-table-column v-if="tenderType==='1'" key="quantity" width="10%" title="数量" data-index="quantity">
                    <template slot-scope="text,record">
                        {{record.quantity}}
                    </template>
                </a-table-column>
                <a-table-column v-if="tenderType==='1'" key="unit" width="10%" title="单位" data-index="unit">
                    <template slot-scope="text,record">
                        {{record.unit}}
                    </template>
                </a-table-column>
                <a-table-column v-if="tenderType!=='1'" key="serviceScope" width="25%" :title="(tenderType!=='1' && tenderType==='2')?'施工范围':'简要服务内容'" data-index="serviceScope">
                    <template slot-scope="text,record">
                        {{record.serviceScope}}
                    </template>
                </a-table-column>
                <a-table-column v-if="tenderType==='2' || tenderType==='3'" key="servicePeriod" width="15%" :title="(tenderType!=='1' && tenderType==='2')?'施工工期':'服务期限'" data-index="servicePeriod">
                    <template slot-scope="text,record">
                        {{record.servicePeriod}}
                    </template>
                </a-table-column>
                <a-table-column key="ask" width="25%" title="其他要求" data-index="ask">
                    <template slot-scope="text,record">
                        {{record.ask}}
                    </template>
                </a-table-column>
            </a-table>

        </a-card>

    </a-modal>

</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'

    export default {
        components: {
        },
        created() {
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                packs:'',
                modalLoading: false,
                tenderType: '',
                columns: [
                    {
                        title: '名称',

                        scopedSlots: { customRender: 'subjectName' }
                    },
                    {
                        title: '规格型号',

                        scopedSlots: { customRender: 'specifications' }
                    },
                    {
                        title: '数量',
                        scopedSlots: { customRender: 'quantity' },

                    },
                    {
                        title: '单位',
                        scopedSlots: { customRender: 'unit' },

                    },
                    {
                        title: '其他要求',
                        scopedSlots: { customRender: 'ask' },

                    },
                    {
                        title: '备注',
                        scopedSlots: { customRender: 'remarks' },

                    }
                ],
                subjectList: []
            }
        },
        methods: {
            onSubmit() {
            },
            initData(packsId) {
                console.log(packsId);
                let that = this
                this.$http.get('/api/v1/supplier/subject/get_subject_list.json?packsId='+packsId).then(function (res) {
                    console.log(res)
                    that.subjectList = res.result
                    that.tenderType = res.tenderType
                })
            }
        }
    };
</script>
<style lang="less" scoped>
    .text-header{
        text-align: center;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 24px;
    }
    .text-header span{
        flex: 1;
    }
    /deep/ .p-0 .ant-card-body{
        padding: 0;
    }
    /deep/ .ant-tabs-nav .ant-tabs-tab {
        font-size: 20px;
        font-weight: bold;
    }
    /deep/ .ant-tabs-bar {
        margin-bottom: 0;
        border-bottom: 3px solid #e6e6e6;
    }
</style>
